import script from "./BrowserSearchList.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrowserSearchList.vue?vue&type=script&setup=true&lang=ts"

import "./BrowserSearchList.vue?vue&type=style&index=0&id=ed4ee590&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed4ee590"]])

export default __exports__